
<div class="row" style="text-align: right;float: right;align-items: center;">
  <div *ngIf="!noIpnSupplier || SupplierCheck">
<a href="{{HelpLink}}" target="_blank" title="Help" data-toggle="tooltip">
  <mat-icon svgIcon="speechquestion" style="width: 21px;height: 21px;margin-top: 13px;color: black;vertical-align: -webkit-baseline-middle;" alt="edit"></mat-icon></a> &nbsp;&nbsp;&nbsp;
</div>
<div *ngIf="SupplierCheck && !noIpnSupplier">
<a (click)="openLink()" style="color: black" title="Contact Support" data-toggle="tooltip" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (openLink())">
  <mat-icon svgIcon="mail" width="17" height="15" alt="edit" style="margin-top: 10px;margin-right: 17px;vertical-align: -webkit-baseline-middle;cursor: pointer;"></mat-icon></a>
</div>
<div *ngIf="!SupplierCheck && !noIpnSupplier">
<button  type="button" title="Contact Support" data-target="#helpPopup" data-toggle="modal" style="border: none;background-color: var(--isa-bg-color);outline: none;">
  <mat-icon svgIcon="mail" width="17" height="15" alt="edit" style="margin-top: 10px;margin-right: 17px;vertical-align: -webkit-baseline-middle;cursor: pointer;"></mat-icon>
</button>
</div>
<div>
<span *ngIf="!noIpnSupplier">
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="feedback_btn" class="renault-feedback-block renault_feedback_btn"
  style="cursor:pointer; height:25px; vertical-align: -webkit-baseline-middle;"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.27 16.1H19l-2.69-1.715h-.81v-1.2h1.18l1.93 1.23-.32-1.245 2.295.045c.17 0 .32-.21.32-.455V3.555c0-.245-.15-.455-.335-.455h-9.635c-.185 0-.335.21-.335.455V7H9.4V3.555A1.6 1.6 0 0 1 10.935 1.9h9.63A1.6 1.6 0 0 1 22.1 3.555v9.205a1.605 1.605 0 0 1-1.535 1.655h-.725l.43 1.685zm-16.54 6H5l2.675-1.715 5.39.03A1.605 1.605 0 0 0 14.6 18.76V9.555A1.6 1.6 0 0 0 13.065 7.9h-9.63A1.6 1.6 0 0 0 1.9 9.555v9.205a1.605 1.605 0 0 0 1.545 1.64h.715l-.43 1.7zm1.68-1.685l.32-1.245-2.295.045c-.185 0-.335-.21-.335-.455V9.555c0-.245.15-.455.335-.455h9.645c.185 0 .335.21.335.455v9.205c0 .245-.15.455-.33.455l-5.745-.03-1.93 1.23zM12 11.4H4.5v1.2H12v-1.2zm-7.5 2H12v1.2H4.5v-1.2zm7.5 2H4.5v1.2H12v-1.2z"/></svg>
  </span>
    <div class="dropdown" style="padding-top: 2px;">
      <button class="btn btn-default dropdown" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"
        style="background-size:cover;box-shadow: none;background-color:var(--isa-bg-color)">
        <span class="caret">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="transparent-background"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.35 6.745A5.055 5.055 0 0 1 14.95 11c3.945 1.03 6.15 4.275 6.15 9.245v1.5h-1.2v-1.5c0-7.31-4.95-8.4-7.9-8.4s-7.9 1.09-7.9 8.4v1.5H2.9v-1.5C2.9 15.27 5.105 12 9.05 11a5.055 5.055 0 0 1-2.4-4.25A5.235 5.235 0 0 1 12 1.65a5.235 5.235 0 0 1 5.35 5.095zM12 2.85a4.035 4.035 0 0 0-4.15 3.9 4.035 4.035 0 0 0 4.15 3.9 4.035 4.035 0 0 0 4.15-3.9A4.035 4.035 0 0 0 12 2.85z"/></svg>
           </span>

      </button>
      <ul class="  dropdown-menu dropdown-menu-right  dropdown-menu-md-end
      dropdown-menu-sm-end
      dropdown-menu-lg-end" aria-labelledby="dropdownMenu1">
        <li style="display: inline;"><a>{{user}}-{{userIPN}} {{userIsSupplier}}</a></li>
        <li class="link"><a (click)="logout()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (logout())">Sign in as different User</a></li>
        <li class="link" *ngIf="superAdmin || admin">
          <a (click)="toggleRoleDropdown($event)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (toggleRoleDropdown($event))">Sign in with different role</a>
          <ul *ngIf="showRoleDropdown">
            <li><a (click)="switchRole('Consult')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (switchRole('Consult'))">Switch to Consult Role</a></li>
            <li><a (click)="switchRole('Buyer')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (switchRole('Buyer'))">Switch to Buyer Role</a></li>
            <li><a (click)="switchRole('Manager')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (switchRole('Manager'))">Switch to Manager Role</a></li>
            <li><a (click)="switchRole('Admin')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (switchRole('Admin'))">Switch to Admin Role</a></li>
          </ul>
        </li>

      </ul>
    </div>
</div>
  <ng-container *ngIf="HAPPI_CLIENT_ID!=''">

    <renault-ng-feedback  [triggerid]="'feedback_btn'"  (loaded)="showFeedbackBtn = $event"
    (onHide)="showFeedbackBtn = false" ipn="{{userIpn}}" irn="IRN-71016"
    apikey="{{HAPPI_API_KEY}}" apiurl="{{HAPPI_URL}}" >
    </renault-ng-feedback>
</ng-container>
</div>
<div class="modal fade"  id="helpPopup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
           <span class="label">SUPPORT</span>
          <button type="button" class="close" id="closeCCBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div style="font-size: large; padding-top: 20px;text-align: initial;font-weight: bold;">
              If you need support, feel free to open a ticket with the following parameters :
              <ul>
                <li>Scope : Renault Application - Key-Users Support</li>
                <li>Category : G01 Purchasing BOP</li>
                <li>Affected service : 04 - BOP Supplier Referencement</li>
              </ul>
              by clicking on this link : <a class="text-style" href="{{helpLink}}" target="_blank">Service Now</a>
          </div>
        </section>
      </div>
      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue ml-2" data-dismiss="modal" style="margin-left: 16%;"> Cancel </button>
        </section>
      </div>
    </div>
  </div>
</div>
